import { Center, Spinner, Stack } from '@chakra-ui/react';
import { useInfiniteQuery } from '@tanstack/react-query';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { CompaniesService } from '@/client';

import { CompanyCard } from './CompanyCard';

const LIMIT = 5;

export function CompaniesCards() {
  const { ref, inView } = useInView();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, status, error } = useInfiniteQuery({
    queryKey: ['companies'],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await CompaniesService.readCompanies({
        offset: pageParam,
        limit: LIMIT,
      });
      return {
        data: response.data,
        nextOffset: response.data.length === LIMIT ? pageParam + LIMIT : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextOffset,
    initialPageParam: 0,
  });

  React.useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  if (status === 'pending') {
    return (
      <Center py={10}>
        <Spinner />
      </Center>
    );
  }

  if (status === 'error') {
    return (
      <Center py={10}>
        <p>Erreur : {(error as Error).message}</p>
      </Center>
    );
  }

  return (
    <>
      <Stack direction="row" wrap="wrap" justifyContent="center" gap={4}>
        {data.pages.map((page, pageIndex) => (
          <React.Fragment key={pageIndex}>
            {page.data.map((company) => (
              <CompanyCard key={company.id} company={company} />
            ))}
          </React.Fragment>
        ))}
      </Stack>

      <Center mt={6} ref={ref}>
        {isFetchingNextPage ? <Spinner /> : hasNextPage && 'Faites défiler pour charger plus...'}
      </Center>
    </>
  );
}
